export default {
  perPageSelect: [
    { text: '10', value: 10 },
    { text: '20', value: 20 },
    { text: '50', value: 50 },
    { text: '100', value: 100 },
  ],
  listaProdutos: [],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    direcao: '',
    order: 'ncm',
    ncm: '',
    sequencia: '',
    produto: '',
    descricao: '',
    dataAbertura: '',
    valor: '',
    precoMedio: '',
    incoterm: '',
    unidadeMedida: '',
    moeda: '',
    exportador: '',
    tipoImportacao: '',
    fabricante: '',
    pesoLiquido: '',
    pesoBruto: '',
    quantidade: '',
    codigoInvoice: '',
    nomeCliente: '',
    paisOrigem: '',
  },
  colDefault: 'ncm',
  directionDefault: '',
  headers: [
    {
      value: 'codigoProcesso',
      i18n: 'codigoProcesso',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'dataAbertura',
      i18n: 'dataAbertura',
      text: '',
      filterable: true,
      filterComponent: 'DateFilter',
    },
    {
      value: 'ncm',
      i18n: 'ncm',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'produto',
      i18n: 'produto',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'valor',
      i18n: 'valor',
      text: '',
    },
    {
      value: 'moeda',
      i18n: 'moeda',
      text: '',
    },
    {
      value: 'incoterm',
      i18n: 'incoterm',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'unidadeMedida',
      i18n: 'unidadeMedida',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },

    {
      value: 'exportador',
      i18n: 'exportador',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'paisOrigem',
      i18n: 'paisOrigem',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'tipoImportacao',
      i18n: 'tipoImportacao',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'fabricante',
      i18n: 'fabricante',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'pesoLiquido',
      i18n: 'pesoLiquido',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'pesoBruto',
      i18n: 'pesoBruto',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'quantidade',
      i18n: 'quantidade',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'nomeCliente',
      i18n: 'cliente',
      text: '',
      filterable: true,
      filterComponent: 'TextFilter',
    },
    {
      value: 'prazoPagamento',
      i18n: 'prazoPagamento',
      text: '',
    },
  ],
};
